import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
    getActionDescriptionModelType,
    useActionBlockFormProps
} from "~/cabinet/vue/client/events/action/types/useActionBlockForm";
import useObjectModel from "~/ts/vuePlugins/useObjectModel";
import {
    OnlineChatClientCallgateActionDescription
} from "~/cabinet/ts/data/events/ActionDescription";
import {requiredRule} from "~/core-ui/ts/CoreUiHelpersMixin";
import TextInputWithVariables from "~/cabinet/vue/interface/tinymce/TextInputWithVariables.vue";
import ObjectHelper from "~/ts/library/ObjectHelper";
import HelpBlock from "~/cabinet/vue/interface/HelpBlock.vue";
import MyTimeSelectorInSeconds from "~/cabinet/vue/interface/form/MyTimeSelectorInSeconds.vue";


const __default__ = {
    name: "OnlineChatCallgateBlockForm"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    ...useActionBlockFormProps<OnlineChatClientCallgateActionDescription>()
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

let props = __props;

let _modelValue = _useModel<getActionDescriptionModelType<OnlineChatClientCallgateActionDescription>>(__props, "modelValue");
let model = useObjectModel(_modelValue, () => {
    return ObjectHelper.jsonClone(props.actionDescription.frontendParams.defaultModel);
});

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form_item, {
      rules: _unref(requiredRule),
      label: "Номер телефона для проверки"
    }, {
      default: _withCtx(() => [
        _createVNode(TextInputWithVariables, {
          modelValue: _unref(model).mobileText,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).mobileText) = $event)),
          "content-variables": _unref(props).contentVariables,
          multiline: false
        }, null, 8, ["modelValue", "content-variables"])
      ]),
      _: 1
    }, 8, ["rules"]),
    _createVNode(_component_el_form_item, {
      rules: _unref(requiredRule),
      label: "Текст для отправки пользователю"
    }, {
      default: _withCtx(() => [
        _createVNode(TextInputWithVariables, {
          modelValue: _unref(model).text,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).text) = $event)),
          "content-variables": _unref(props).actionDescription.frontendParams.recipientIdContentVariables,
          multiline: true,
          bbcode: ""
        }, null, 8, ["modelValue", "content-variables"])
      ]),
      _: 1
    }, 8, ["rules"]),
    _createVNode(_component_el_form_item, { label: "Запоминать проверку" }, {
      default: _withCtx(() => [
        _createVNode(MyTimeSelectorInSeconds, {
          modelValue: _unref(model).rememberTtl,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).rememberTtl) = $event)),
          min: 1
        }, null, 8, ["modelValue"]),
        _createVNode(HelpBlock, null, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode(" Последний проверенный у клиента номер телефона будет запоминаться на заданный период. ", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, null, {
      default: _withCtx(() => [
        _createVNode(HelpBlock, null, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createElementVNode("p", null, "CallGate - это услуга, позволяющая убедиться, что номер телефона принадлежит вашему посетителю.", -1),
            _createElementVNode("p", null, " Для проверки посетитель должен будет сделать дозвон со своего номера телефона на наш сервисный номер телефона. После этого звонок будет автоматически сброшен, и идентификация пользователя будет успешно пройдена. ", -1),
            _createElementVNode("p", null, [
              _createTextVNode(" Услуга платная. С подробностями можно ознакомиться в "),
              _createElementVNode("a", {
                href: "/cabinet/callGate/about",
                target: "_blank"
              }, "личном кабинете"),
              _createTextVNode(". ")
            ], -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})